import React from "react";

const Footer = () => {
  return ( 
    <div className="footerSection">
      <div className="footertext fade-in3">
        <span className="footertext1">Version: 0.1</span>
        <span className="footertext2">© Copyrights 2021</span>
      </div>
      <div className="footerLine slide-in-bottom"></div>
      <div className="bottomCurve slide-in-left2"></div>
    </div> 
  );
};

export default Footer;